var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacyPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.796,
    height: 64,
    viewBox: "0 0 61.796 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-4059691",
    transform: "translate(-6.651 -5.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47423",
    "data-name": "Path 47423",
    d: "M67.589,46.614,52.675,37.55l14.915-9.064a1.78,1.78,0,0,0,.571-2.478L60.771,14.5a1.765,1.765,0,0,0-2.486-.511L45.811,22.47l.375-15.095A1.78,1.78,0,0,0,44.414,5.55H30.708a1.78,1.78,0,0,0-1.772,1.825l.375,15.095-12.5-8.479a1.765,1.765,0,0,0-2.486.511l-7.4,11.505A1.78,1.78,0,0,0,7.5,28.485L22.425,37.55,7.51,46.614a1.78,1.78,0,0,0-.571,2.478l7.4,11.505a1.765,1.765,0,0,0,2.486.511L29.289,52.63l-.375,15.095a1.78,1.78,0,0,0,1.772,1.825H44.391a1.78,1.78,0,0,0,1.772-1.825L45.811,52.63l12.474,8.479a1.765,1.765,0,0,0,2.486-.511l7.4-11.505a1.78,1.78,0,0,0-.578-2.478Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyPlain);
export default __webpack_public_path__ + "static/media/pharmacy-plain.d428e30387eca35ade6c6cb571a49160.svg";
export { ForwardRef as ReactComponent };